module.exports = __webpack_public_path__ + "static/media/cw.32406ab8.png";